import React from "react";
import { Route, Routes } from "react-router-dom";
import Account from "./components/Account";
import ProtectedRoute from "./components/ProtectedRoute";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import { UserAuthContextProvider } from "./context/UserAuthContext";


function App() {
  return (
    <div>
      <UserAuthContextProvider>
        <Routes>
          <Route path='/' element={<Signin />} />
          <Route path='/signup' element={<Signup />} />
          <Route path='/account' element={<ProtectedRoute><Account /></ProtectedRoute>} />
        </Routes>
      </UserAuthContextProvider>

    </div>
  );
}

export default App;
